import React from "react";
import Avatar from '@material-ui/core/Avatar';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import {red} from '@material-ui/core/colors';
import formatValue from "../../../../../../Utils/ListUtils/FormatValue";
import JsonScreenHoc from "../../../../../../HocHelpers/JsonScreenHoc";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

const useStyles = makeStyles(() => ({
    container: {
        padding: 10,
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        backgroundColor: red[500],
    },
    title: {
        paddingLeft: 10,
        flexGrow: 1
    },
    text: {
        fontSize: '0.9rem',
        lineHeight: 1.8
    }
}));

const FeedHeader = (props) => {
    const {author, createDate, editFeedPost, userId, uniqueUsers} = props;
    const classes = useStyles();
    const authorObject = (uniqueUsers || []).find(u => u.id === author) || {};
    return (
        <div className={classes.container}>
            <Avatar aria-label="recipe" className={classes.avatar}>
                {author.charAt(0).toUpperCase()}
            </Avatar>
            <div className={classes.title}>
                <Typography className={classes.text} autoCapitalize>
                    {authorObject.name || author}
                </Typography>
                <Typography color={"textSecondary"} className={classes.text}>
                    {formatValue(createDate, 'datetime')}
                </Typography>
            </div>
            {userId === author && (
                <IconButton onClick={editFeedPost}>
                    <Icon>
                        edit
                    </Icon>
                </IconButton>
            )}
        </div>
    )
};

export default FeedHeader

FeedHeader.defaultProps = {
    author: ''
};